<template>
    <div>
        <!-- register的头部 -->
        <header class="register-header layout-header">
            <van-icon name="arrow-left" />
            <!-- 注册账号 -->
            <b>アカウント登録</b>
            <div>
                <!-- 已有账号 -->
                <span>アカウントをお持ちの方? </span>
                <!-- 立即登录 -->
                <span @click="handleShowLoginDialogBtnClick">今すぐログイン</span>
            </div>
        </header>

        <!-- popup -->
            <!-- 放在register里面就可以，如果放到外面，点击之后右上角的按钮会出现残影 -->
            <!-- v-model:show 看上去像vue3语法，实际是vant底层emit的自定义事件，但是
                eslint会错把它当成vue3语法报错，因为你写的是vue2项目，只需要添加底下那句注释，
                让它忽略下一行就行了 -->
            <!-- eslint-disable-next-line -->
            <van-popup v-model:show="showCenter" 
                       round 
                       closeable 
                       close-icon="close">
                <!-- 账号登录 -->       
                <h2>ログイン</h2>
                <van-form>
                    <!-- 账号 -->
                    <div class="field-block">
                        <div class="label">アカウント</div>
                        <!-- 请输入账号/手机号 -->
                        <van-field placeholder="アカウント又はスマホ番号を入力する" v-model="form.account"/>
                    </div>
               
                    <!-- 密码 -->
                    <div class="field-block">
                        <!-- 密码 -->
                        <div class="label">パスワード</div>
                        <!-- @click-right-icon这个事件是vantUI底层emit的 -->
                        <!-- 请输入密码 -->
                        <van-field placeholder="パスワードを入力する" 
                                :type="showPassword ? 'text':'password'" 
                                :right-icon="showPassword ?'eye-o':'closed-eye'" 
                                @click-right-icon="togglePassword" 
                                v-model="form.password" />
                    </div>

                    <!-- 图形验证码 -->
                <div class="field-block">
                    <!-- 图形验证码 -->
                    <div class="label">画像認証コード</div>
                    <div class="veri-code-box">
                        <!-- 请输入验证码 -->
                        <van-field placeholder="認証コードを入力する" class="veri-code-input" v-model="form.logVeriCode"/>
                        <div class="veri-code-img" @click="fetchVerifyCode">
                            <van-skeleton v-if="verifyCodeLoading" row="1" />
                            <img :src="captchaImg" v-else>
                        </div>
                    </div>
                </div>

                    <!-- 登录按钮 -->
                    <!-- 登录 -->
                    <van-button color="var(--red-light)" @click="handleLoginBtnClick" :loading="loginBtnLoading">登録</van-button>
                </van-form>
            </van-popup>
    </div>
</template>
<script>
//导入mixins
import getVerifyCode from "@/mixins/getVerifyCode"
//login不是默认暴露，所以必须写小括号
import {login} from "@/api/user"
// import { Toast } from "vant"

export default {
    name: "RegisterHeader",
    mixins: [getVerifyCode],
    data() {
        return {
            //登录弹出框是否显示
            showCenter: false,

            //van-popup密码输入框的密码是否显示
            showPassword: false,

            // vanpopup表单
            form: {
                //账号
                account: "",

                //登录验证码
                logVeriCode: "",
                
                // 密码
                password: ""
            },

            loginBtnLoading: false
        }
    },

    methods: {
        // van-popup切换是否显示密码
        togglePassword() {
            this.showPassword = !this.showPassword
        },

        //显示登录弹窗按钮的点击回调
        handleShowLoginDialogBtnClick() {
            //让登录的dialog出现
            this.showCenter = true;
            //一旦点击立即登录按钮，就获取验证码
            this.fetchVerifyCode();
        },

        //登录按钮点击的回调
        async handleLoginBtnClick() {
            console.log('开始点击了');
            this.loginBtnLoading = true
            try {
                const res = await login(this.form)
                // console.log('开始点击了');
                console.log('登录接口返回结果:',res)
                // this.$toast.success(res.msg)
                this.$toast.success('できた!')
                // const token = res.data.tokenId; // 看你接口返回什么字段
                // 这个指令就是控制vuex的，用来启动actions
                // store底下，如果是工程化的vue2项目，是会分成若干个模块的
                // 底下的user，意思是，需要启动user.js里的actions的setToken方法，而不是别的模块里的js文件的actions
                await this.$store.dispatch("user/setData", res.data) // 存入 Vuex
                //清空表格
                Object.keys(this.form).forEach(k => this.form[k] = "")
                this.showCenter = false
                //跳转到主页
                this.$router.push('/home')
            } catch (error) {
                console.log(error);    
            } finally {
                this.loginBtnLoading = false
            }
        }
    }
}
</script>
<style scoped>

  /* 注册组件头部 */
.register-header {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
}

.register-header b {
    font-size: 21px;
}

.register-header div {
    display: flex;
    gap: 7px;
}

.register-header div span:nth-child(1) {
    color: #aaa;
}

/* 立即登录按钮 */
.register-header div span:nth-child(2) {
    color: var(--red-light);
}

.van-popup {
    width: 90%;
    padding: 20px;
    /* margin: 0 20px; */
}

/* 账号登录字样 */
.van-popup h2 {
    padding: 0;
    margin: 0 0 20px 0;
}

/* 表格 每个条目 */
.van-popup .field-block {
    margin-bottom: 10px;
}
/* 表格 每个条目的边框 */
.van-popup .field-block .van-cell {
    border: 1px solid #eee;
    border-radius: 8px;
}

/* 表格 条目 标签 */
.van-popup .field-block .label {
    color: #555;
    margin-bottom: 5px;
}

.van-popup .van-button {
    width: 100%;
    border-radius: 10px;
    font-weight: bold;
    font-size: 17px;
    letter-spacing: 2px;
    margin-top: 15px;
}

:deep(.van-popup__close-icon--top-right) {
    top: 25px;
}

/* 表格 每个条目 */
.field-block {
    margin-bottom: 10px;
}
/* 表格 每个条目的边框 */
.field-block .van-cell {
    border: 1px solid #eee;
    border-radius: 8px;
}

/* 表格 条目 标签 */
.field-block .label {
    color: #555;
    margin-bottom: 5px;
}

/* 验证码外框 */
.veri-code-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

/* 验证码输入框 */
.veri-code-input {
    flex: 1;
}

/* 验证码图片 容器 */
.veri-code-img {
    flex: 1;
    /* 因为父级盒子没有固定高度，是被van-field给撑大的，height: 100%;这句话只能继承父亲的固定高度，无法继承兄弟元素的高度 */
    /* height: 100%; */
    height: 46px;
    line-height: 46px;
    background-color: #eee;
    font-weight: bold;
    border-radius: 5px;
    text-align: center;
    overflow: hidden;
}

/* 验证码图片 图片 */
.veri-code-img img {
    width: 100%;
    height: 100%;
}

/* 骨架屏 */
.van-skeleton {
    padding: 0;
}

.van-skeleton__row {
    height: 46px;
    width: 200px !important;
}
</style>